import { useState, useMemo, useEffect } from "react";
import useImage from "use-image";

type useMultiImageLoaderReturn = {
  completes: string[];
  errors: string[];
  isError: boolean;
  isLoading: boolean;
  isComplete: boolean;
};

const useMultiImageLoader = (srcs: string[]): useMultiImageLoaderReturn => {
  const [progress, setProgress] = useState(0);
  const [completes, setCompletes] = useState<string[]>([]);
  const [errors, setErrors] = useState<string[]>([]);
  const currentSrc = useMemo(() => srcs[progress], [srcs, progress]);

  const [, status] = useImage(currentSrc);

  // 画像読み込み完了時の処理
  useEffect(() => {
    if (status !== "loaded") return;

    // 読み込みが終わった画像のパスを保存
    setCompletes((prev) => [...prev, currentSrc]);

    setProgress((prev) => prev + 1);
  }, [status, currentSrc]);

  // エラー時の処理
  useEffect(() => {
    if (status !== "failed") return;

    // エラーが起きた画像のパスを保存
    setErrors((prev) => [...prev, currentSrc]);

    setProgress((prev) => prev + 1);
  }, [status, currentSrc]);

  return {
    completes,
    errors,
    isLoading: errors.length + completes.length < srcs.length,
    isError: errors.length > 0,
    isComplete: completes.length >= srcs.length,
  };
};

export default useMultiImageLoader;
